module.exports = __webpack_public_path__ + "img/neighbor-5-image.58ffcd52.jpg";